import { IconType } from "./types";

export function ToggleIcon({ color = "#FF5932", scale = 1 }: IconType) {
  return (
    <svg
      width={scale * 15}
      height={scale * 13}
      viewBox="0 0 15 13"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.64645 12.3536C3.84171 12.5488 4.15829 12.5488 4.35355 12.3536L7.53553 9.17157C7.7308 8.97631 7.7308 8.65973 7.53553 8.46447C7.34027 8.2692 7.02369 8.2692 6.82843 8.46447L4 11.2929L1.17157 8.46447C0.97631 8.2692 0.659728 8.2692 0.464466 8.46447C0.269204 8.65973 0.269204 8.97631 0.464466 9.17157L3.64645 12.3536ZM3.5 1L3.5 12L4.5 12L4.5 1L3.5 1Z"
        fill="inherit"
      />
      <path
        d="M10.622 0.646446C10.8173 0.451184 11.1339 0.451184 11.3291 0.646446L14.5111 3.82843C14.7064 4.02369 14.7064 4.34027 14.5111 4.53553C14.3159 4.7308 13.9993 4.7308 13.804 4.53553L10.9756 1.70711L8.14716 4.53553C7.9519 4.7308 7.63531 4.7308 7.44005 4.53553C7.24479 4.34027 7.24479 4.02369 7.44005 3.82843L10.622 0.646446ZM10.4756 12L10.4756 1L11.4756 1L11.4756 12L10.4756 12Z"
        fill="inherit"
      />
    </svg>
  );
}
